$(document).ready(function() {
    $('#mass-reception-button').on('click', function(e){
        e.preventDefault();
        $('#mass_reception').val('1');
        $('#advanced_search_form_reception').trigger('submit');
    })

    $('#selectAllCommandLines').on('click', toggleQuantity);

    $('#quantity-reception-form').on('submit', setQuantityWithValue)
});

/**
 * Function permettant de remplir tous les champs de réception automatiquement par leur valeur max
 */
function toggleQuantity() {
    if ($(this).text() == 'Tout remplir')
    {
        $(this).attr('type', 'button');
        $('.ligne_commandes').each(function(index) {
            $(this).find('input.reception-input').val($(this).children('td')[2].innerText);
        });
        $(this).text('Annuler');
    }
    else
    {
        $(this).text('Tout remplir');
        $(this).attr('type', 'reset');
    }
}

/**
 * Function permettant de remplir tous les champs de récepton automatiquement par une valeur prédefinie dans le formulaire modal
 * @param {*} e event JS
 */
function setQuantityWithValue(e) {
    e.preventDefault()
    // Set the inputs
    $('.ligne_commandes').each(function(index) {
        $(this).find('input.reception-input').val($('#fillQuantityInput').val());
    });
    // Close the modal one set
    $('#quantityModal').modal('hide');
}